export default __webpack_public_path__ + "static/media/gallery6.72af8153.png";